<template>
  <div class="container pb-4 mb-4">

        <!-- top row -->
        <div class="row">
          <div class="col text-right mb-2">

          <a href="#/" @click="changeStatus()">{{ article.status }}</a>

          <span v-if="article.status != 'Incomplete' && article.title">
             <span class="mx-2">&bull;</span><a :href="'/article/' + article.id + '/' + makeSlug(article.title)">View</a>
          </span>

          <span v-if="submitting">
            <i class="fas fa-spinner fa-spin fa-1x ml-3"></i>
          </span>

          <span v-else-if="article.banner">
            <span class="mx-2">&bull;</span><a href="#/" @click="saveForm()">Save</a>
          </span>
        </div>
      </div>

        <!-- card -->
        <div class="card 0">
          <div class="card-body">

            <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>

              <div v-else>

                <div class="row mt-0 pb-0">

                  <div class="col-md-4">
                    <label class="form-label" for="fullname">Category</label>

                    <i v-if="loading_categories" class="fas fa-spinner fa-spin fa-1x"></i>

                      <select v-else class="form-control2" v-model="article.category_id">
                          <option v-for="(category, index) in categories" :key="index" :value="category.id">{{category.name}}</option>
                      </select>

                  </div>

                  <div class="col-md-8">
                    <label class="form-label" for="fullname">Title</label>
                    <input
                      type="text"
                      class="form-control2 title"
                      v-model.trim="article.title" 
                      style="padding: 0.49rem 0.8rem;" />
                  </div>

                </div>

                <div class="row mt-2 pb-0">
                  <div class="col">
                    <label class="form-label" for="fullname">Content</label>
                    <div>
                    <trumbo-editor v-model="article.content"></trumbo-editor>
                  </div>
                  <div class="text-center">
                    <div v-if="submitting" class="text-center py-3">
                  <i class="fas fa-spinner fa-spin fa-1x"></i>
                </div>
                <button
                  v-if="article.category_id && article.title && article.content && article.banner && !submitting"
                  type="submit"
                  @click="saveForm()"
                  class="btn btn-danger btn-block mt-3 mb-3"
                  tabindex="4">Save Article</button>
                  </div>
                  </div>
                </div>

<!--
                <div class="pt-3">
                  <div class="row mb-2 mt-0">
                    <div class="col">
                      <div>
                        <small v-if="!article.banner">Please upload article image</small>
                      </div>
                    </div>

                    <div class="col text-right">

                      <div v-if="uploading_image">
                        <i class="fas fa-spinner fa-spin fa-1x"></i>
                      </div>
                      <form
                        v-else
                        @submit="uploadArticleImage"
                        enctype="multipart/form-data">
                        <label for="account-upload" class="btn btn-danger">
                          <span v-if="article.banner">Change Image</span>
                          <span v-else>Upload Image</span>
                        </label>
                        <input
                          type="file"
                          id="account-upload"
                          accept="image/*"
                          hidden
                          class="form-control2 mt-2"
                          v-on:change="uploadArticleImage" />
                      </form>
                    </div>
                  </div>
                  <img v-if="article.banner" :src="article.banner" class="article-banner" />
                </div>
-->

            </div>
            </div>
        </div>

        <!-- <div class="row" v-if="article.category_id && article.title && article.content && article.banner">
          <div class="col-6 pt-2">
            <label class="form-label" for="fullname">Schedule</label>
            <input type="date" @change="updateSchedule" class="form-control2 dt-full-name" v-model="article.scheduled" />
            <div class="col text-right pt-2" v-if="article.status =='Scheduled'"><a href="#" class="remove" @click="removeSchedule">remove schedule</a></div>
          </div>
        </div> -->
  </div>
</template>

<script>

export default {
  props: ['article_id'],

  data() {
    return {
      article: {},
      submitting: false,
      submitted: false,
      submitStatus: null,
      loading: false,
      uploading_image: false,
      loading_categories: false,
    };
  },

  created() {
    this.getArticle();
    this.getCategories();
  },

  methods: {

    updateSchedule() {

      let originalObject = this;

      axios
        .post('/articles/update-schedule', {
          article_id: this.article.id,
          date: this.article.scheduled,
        })
        .then(function (response) {
          console.log(response.data);
          originalObject.article.status = 'Scheduled';
          originalObject.$toaster.success('Schedule updated', { timeout: 3000 });
        });
    },

    removeSchedule() {

      let originalObject = this;

      axios
          .post('/articles/remove-schedule', { article_id: this.article.id })
          .then(function (response) {
            originalObject.article.scheduled = null;
            originalObject.article.status = 'Active';
            originalObject.$toaster.success('Schedule removed', { timeout: 3000 });
          });
    },

    changeStatus() {
      let existingObj = this;

      if (this.article.title && this.article.content && this.article.banner) {
        axios
          .post('/articles/change-status', {
            article_id: this.article.id,
            status: this.article.status,
          })
          .then(function (response) {
            existingObj.article.status = response.data;
          });
      } else {
        existingObj.sweetfire('Cannot change status');
      }
    },

    async uploadArticleImage(e) {
      this.file = e.target.files[0];

      let existingObj = this;

      var document_response = this.document_check(this.file, "image");

      if (document_response.success !== true)
        this.sweetfire(document_response.message);
      else {
        this.uploading_image = true;

        const config = { headers: { "content-type": "multipart/form-data" } };

        let data = new FormData();
        data.append("file", this.file);
        data.append("article_id", this.article_id);

        await axios
          .post('/articles/upload-banner', data, config)
          .then(function (response) {
            existingObj.uploading_image = false;
            existingObj.banner = response.data;
          });
      }
    },

    getArticle() {

      this.loading = true;

      axios.get('/articles/info/' + this.article_id)
      .then((response) => {
        this.article = response.data;
        this.article.banner = 'https://marketing.com.au/wp-content/uploads/2015/11/web-analytics-tools-2000x1143.jpg';
        this.loading = false;
      });
    },

    getCategories() {
      this.loading_categories = true;
      axios.get('/article-categories/get').then((response) => {
        this.categories = response.data;
        this.loading_categories = false;
      });
    },

    saveForm() {
      
      this.submitting = true;

      if      (!this.article.category_id) { this.sweetfire('Please choose article category') }
      else if (!this.article.title) { this.sweetfire('Please enter title') }
      else if (!this.article.content) { this.sweetfire('Please enter content') }
      else if (!this.article.banner) { this.sweetfire('Please upload banner') }
      else { this.saveArticle(); }
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: "Ok",
        customClass: { title: "popup-title" },
      });
    },

    saveArticle() {
      axios
        .post('/articles/save', { article: this.article })
        .then((response) => {
          if (response.data.success) {

            window.open('/article/' + this.article.id + '/' + this.makeSlug(this.article.title), '_self')

          } else { 
            this.sweetfire(response.data.message) 
            this.submitting = false;
            }
          
        });
    },
  },
};
</script> 

<style scoped>
.form-control.title {border-radius:5px !important}
a.remove {font-size:80%;}
a.remove:link, a.remove:visited { color: #222222; }
a.remove:hover { color: #e92e56; }
a.remove:active { color: #222222; }
textarea.form-control { font-size: 1rem; }
img.thumbnail { width: 100%; }
.btn-outline-secondary:hover { color: #6c757d; border-color: #6c757d; background-color: #fff; }
</style>